import React, { useState, useEffect } from 'react';
import { apiRequest } from '../Utils/APIUtils';
import moment from 'moment';
import './ManageEnrolments.css';
import EnrollmentProgressStepper from "../EnrollmentProgressStepper/EnrollmentProgressStepper";
import { useTranslation } from 'react-i18next';
import ModalPopup from "../ModalPopup/ModalPopup";
import { useNavigate } from "react-router-dom";

const ManageEnrolments = () => {
    const { t } = useTranslation();
    const [enrolments, setEnrolments] = useState(null);
    const [enrolmentToDelete, setEnrolmentToDelete] = useState(null);
    const [enrolmentToDuplicate, setEnrolmentToDuplicate] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        apiRequest('api/enrolments')
            .then(enrolments => {
                setEnrolments(enrolments);
            })
            .catch(error => console.error('Error:', error))

    }, []);

    const confirmDeleteEnrolment = (enrolmentId) => {

        apiRequest(`api/enrolment/${enrolmentId}`, 'DELETE')
            .then(() => {
                setEnrolments(enrolments.filter(enrolment => enrolment._id !== enrolmentId));
            })
            .catch(error => {
                //TODO: SHouldn't really use alerts...
                alert('Error deleting enrolment');
                console.error('Error:', error)
            })
    }

    const confirmDuplicateEnrolment = (enrolmentId) => {

        apiRequest(`api/duplicate-enrolment/${enrolmentId}`, 'POST')
            .then((newEnrolment) => {
                //setEnrolments([newEnrolment, ...enrolments]);
                navigate(`/enrolment/${newEnrolment._id}`);
            })
            .catch(error => {
                //TODO: SHouldn't really use alerts...
                alert('Error duplicating enrolment');
                console.error('Error:', error)
            })
    }

    const enrolmentIsFamily = (enrolmentId) => {
        const enrolment = enrolments.find(enrolment => enrolment._id === enrolmentId);
        if (!enrolment) { return false; }
        return enrolment.application && enrolment.application.childApplicationIds;
    }

    return (
        <div className={'manage-enrolments'}>
            {enrolmentToDelete &&
                <ModalPopup
                    show={true}
                    onClose={() => setEnrolmentToDelete(null)}
                >
                    <div>Are you sure you want to delete this enrolment? This cannot be undone.</div>
                    {enrolmentIsFamily(enrolmentToDelete) &&
                        <div>NOTE: Deleting this family enrolment will also delete all child enrolments!</div>
                    }
                    <div>
                        <button className={'clickable'}
                            onClick={() => {
                                confirmDeleteEnrolment(enrolmentToDelete);
                                setEnrolmentToDelete(null);
                            }}>
                            Yes
                        </button>

                        <button className={'clickable'}
                            onClick={() => {
                                setEnrolmentToDelete(null);
                            }}>
                            No
                        </button>
                    </div>

                </ModalPopup>
            }

            {enrolmentToDuplicate &&
                <ModalPopup
                    show={true}
                    onClose={() => setEnrolmentToDuplicate(null)}
                >
                    <div>Are you sure you want to duplicate this enrolment?</div>
                    <div>
                        <button className={'clickable'}
                            onClick={() => {
                                confirmDuplicateEnrolment(enrolmentToDuplicate);
                                setEnrolmentToDuplicate(null);
                            }}>
                            Yes
                        </button>

                        <button className={'clickable'}
                            onClick={() => {
                                setEnrolmentToDuplicate(null);
                            }}>
                            No
                        </button>
                    </div>

                </ModalPopup>
            }

            {enrolments &&
                <div className={'enrolments-list'}>
                    {(!enrolments || enrolments.length === 0) &&
                        <div className={'enrolment-tile'}>
                            {t('No enrolments found.')}
                        </div>
                    }

                    {enrolments.map(enrolment => {
                        let beneName = t('Beneficiary name Unknown')
                        if (enrolment.beneficiary) {
                            beneName = enrolment.beneficiary.firstName && enrolment.beneficiary.lastName ? `${enrolment.beneficiary.firstName} ${enrolment.beneficiary.lastName}` : t('Beneficiary name unknown');
                        }
                        const docusignStatus = enrolment.docusign ? enrolment.docusign.status : 'PRE_FEATURE';
                        return (
                            <div className={'enrolment-tile'} key={enrolment._id}>
                                <div className={'beneficiary-name'}>
                                    <span>{beneName}</span>
                                    {enrolment.application && enrolment.application.childApplicationIds &&
                                        <span
                                            data-tooltip-content={t('Family Enrolment')}
                                            data-tooltip-id={'tooltip'}
                                        >
                                            <span className="material-symbols-outlined">
                                                diversity_3
                                            </span>
                                            +{enrolment.application.childApplicationIds.length}
                                        </span>
                                    }
                                </div>
                                <div className={'date-updated'}>
                                    {moment(enrolment.dateCreated).format("MMMM Do YYYY [at] h:mm a")}
                                </div>

                                <div className={'action-buttons'}>
                                    <span className={'edit-button'}>
                                        <a href={'/enrolment/' + enrolment._id}>
                                            {enrolment.state === 'pre-docusign' &&
                                                <span className="material-symbols-outlined"
                                                    data-tooltip-content={'View/Edit Enrolment'}
                                                    data-tooltip-id={'tooltip'}
                                                    data-tooltip-place="bottom"
                                                >
                                                    edit_square
                                                </span>
                                            }
                                            {enrolment.state !== 'pre-docusign' &&
                                                <span className="material-symbols-outlined"
                                                    data-tooltip-content={'View Enrolment'}
                                                    data-tooltip-id={'tooltip'}
                                                    data-tooltip-place="bottom"
                                                >
                                                    pageview
                                                </span>
                                            }
                                        </a>
                                    </span>
                                    {enrolment.state === 'pre-docusign' &&
                                        <span className={'delete-button'}>
                                            <span
                                                onClick={() => setEnrolmentToDelete(enrolment._id)}
                                                className={'clickable material-symbols-outlined'}
                                                data-tooltip-content={'Delete Enrolment'}
                                                data-tooltip-id={'tooltip'}
                                                data-tooltip-place="bottom"
                                            >
                                                delete
                                            </span>
                                        </span>
                                    }

                                    <span
                                        onClick={() => setEnrolmentToDuplicate(enrolment._id)}
                                        className={'clickable material-symbols-outlined'}
                                        data-tooltip-content={'Duplicate Enrolment'}
                                        data-tooltip-id={'tooltip'}
                                        data-tooltip-place="bottom"
                                    >
                                        content_copy
                                    </span>
                                </div>

                                <EnrollmentProgressStepper hideLabels={false}
                                    state={{
                                        ...enrolment,
                                        enrollment: {
                                            state: enrolment.state,
                                            docusign: {
                                                status: docusignStatus
                                            }
                                        }
                                    }}

                                />
                            </div>
                        )
                    })}
                </div>
            }
        </div>
    );
}

export default ManageEnrolments;